import { getStandard } from "./datetime"

const datetime = {
    getStandard
}

export default datetime